import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { informationFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  InformationState,
  isInformationStepValid,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import InfoIcon from "@redotech/redo-web/icon-old/info.svg";
import { produce } from "immer";
import * as React from "react";
import { StepDownstream, StepType, StepTypeDetailsProps } from "../step";

export const INFORMATION = (
  Details: React.ComponentType<StepTypeDetailsProps<InformationState>>,
): StepType<InformationState, ModelStep.Information> => ({
  Details: (props: StepTypeDetailsProps<InformationState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for Information step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  empty: { message: "", continueButtonText: "", header: "", next: undefined },
  layout() {
    return BlockLayout.FULL;
  },
  title: STEP_TYPE_NAMES[ModelStep.INFORMATION],
  valid(state) {
    return isInformationStepValid(state).valid;
  },
  fromModel(model, id) {
    return informationFromModel(model, id);
  },
  toModel(state, id) {
    return {
      stepUUID: state.stepUUID,
      customTitle: state.customTitle,
      type: ModelStep.INFORMATION,
      message: state.message,
      continueButtonText: state.continueButtonText,
      header: state.header,
      next: state.next ? id(state.next) : undefined,
    };
  },
  Icon: InfoIcon,
});
